"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var padNumber_1 = require("./padNumber");
/**
 * formatuje datę i czas do formatu yyyy-MM-dd HH:mm:ss
 * @param dt data typu Date
 */
function fdatetime(dt, format) {
    return exports.formatDateFunction[format || 'yyyy-MM-dd HH:mm:ss'](dt);
    // return fdate(dt) + ' ' + ftime(dt);
}
exports.default = fdatetime;
exports.monthNames = ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień'];
exports.monthShort = ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'];
exports.dayNames = ['poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota', 'niedziela'];
var dayNames2 = ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota'];
exports.dayShort = ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So', 'N'];
var dayShort2 = ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So', 'N'];
exports.formatDateFunction = {
    'dd.MM.yyyy': function (dt) { return padNumber_1.default(dt.getDate()) + '.' + padNumber_1.default(dt.getMonth() + 1) + '.' + dt.getFullYear(); },
    'yyyy-MM-dd': function (dt) { return dt.getFullYear() + '-' + padNumber_1.default(dt.getMonth() + 1) + '-' + padNumber_1.default(dt.getDate()); },
    'MMMM yyyy': function (dt) { return exports.monthNames[dt.getMonth()] + " " + dt.getFullYear(); },
    'MMM yyyy': function (dt) { return exports.monthShort[dt.getMonth()] + " " + dt.getFullYear(); },
    'dddd': function (dt) { return dayNames2[dt.getDay()]; },
    'ddd': function (dt) { return dayShort2[dt.getDay()]; },
    'dd': function (dt) { return padNumber_1.default(dt.getDate()); },
    'd': function (dt) { return dt.getDate().toString(); },
    'MMMM': function (dt) { return exports.monthNames[dt.getMonth()]; },
    'MMM': function (dt) { return exports.monthShort[dt.getMonth()]; },
    'MM': function (dt) { return padNumber_1.default(dt.getMonth() + 1); },
    'M': function (dt) { return (dt.getMonth() + 1).toString(); },
    'HH': function (dt) { return padNumber_1.default(dt.getHours()); },
    'H': function (dt) { return dt.getHours().toString(); },
    'mm': function (dt) { return padNumber_1.default(dt.getMinutes()); },
    'm': function (dt) { return dt.getMinutes().toString(); },
    'ss': function (dt) { return padNumber_1.default(dt.getSeconds()); },
    's': function (dt) { return dt.getSeconds().toString(); },
    'HH:mm:ss': function (dt) { return padNumber_1.default(dt.getHours()) + ":" + padNumber_1.default(dt.getMinutes()) + ":" + padNumber_1.default(dt.getSeconds()); },
    'dd.MM.yyyy HH:mm:ss': function (dt) { return exports.formatDateFunction['dd.MM.yyyy'](dt) + ' ' + exports.formatDateFunction['HH:mm:ss'](dt); },
    'yyyy-MM-dd HH:mm:ss': function (dt) { return exports.formatDateFunction['yyyy-MM-dd'](dt) + ' ' + exports.formatDateFunction['HH:mm:ss'](dt); }
};
//# sourceMappingURL=fdatetime.js.map